import { Box, Typography } from "@mui/material";
import { StageProps } from "../../pages/InitialSettings/types";
import { styles } from "../../pages/InitialSettings/styles";
import { stageStyles } from "./styles";
import { TEXT_COLOR } from "../../theme";

export const Stage: React.FC<StageProps> = ({
  icon,
  title,
  description,
  isActive,
  handleStageChange,
  currentStage,
}) => (
  <Box
    sx={styles.stageContainer}
    onClick={() => handleStageChange(currentStage)}
  >
    {icon}
    <Box>
      <Typography
        style={{
          ...stageStyles.title,
          color: isActive ? TEXT_COLOR : "#697177",
          fontWeight: "bold",
        }}
      >
        {title}
      </Typography>

      <Typography
        style={{
          ...stageStyles.description,
          color: isActive ? TEXT_COLOR : "#697177",
        }}
      >
        {description}
      </Typography>
    </Box>
  </Box>
);
